import { Component, computed, inject } from '@angular/core';
import { RestaurantConfigService } from '../../services/restaurant-config.service';
import {NgOptimizedImage} from '@angular/common';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss',
  imports: [
    NgOptimizedImage
  ]
})
export class AboutComponent {
  private readonly restaurantConfig = inject(RestaurantConfigService);

  readonly profile = this.restaurantConfig.profile;
  readonly gallery = this.restaurantConfig.gallery;
  readonly features = this.restaurantConfig.highlights;

  readonly showReservation = computed(
    () => this.restaurantConfig.config().features.reservation
  );

  readonly aboutImage = computed(() => {
    const firstGallery = this.gallery()[0]?.imageUrl;
    const hero = this.profile()?.heroImageUrl;
    return (
      firstGallery ??
      hero ??
      'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800&q=80'
    );
  });

  readonly aboutImageAlt = computed(
    () => this.gallery()[0]?.altText?.trim() || 'Kanyar Büfé Pákozd – étterem és terasz a Velencei-tó partján'
  );
}
